import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  mediaModalController: [
    'runtimeConstant',
    '$scope',
    'treeService',
    '$filter',
    'service',
    '$uibModalInstance',
    'exportedMediaModel',
    'ETreeItemTypes',
    function (
      runtimeConstant,
      $scope,
      treeService,
      $filter,
      service,
      $uibModalInstance,
      ExportedMedia,
      ETreeItemTypes
    ) {
      'use strict';

      function loadFolders() {
        treeService.getRepositories(true).then(
          function (data) {
            $scope.folders = data;
          },
          function () {
            swal.fire({
              title: 'Erro ao carregar pastas',
              text: 'Tivemos um problema ao carregar suas pastas, por favor recarrege a página',
              icon: 'error',
              showCancelButton: true,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: $filter('translate')('RETRY'),
              showLoaderOnConfirm: true,
              preConfirm: function () {
                return new Promise(function (resolve) {
                  $scope.loadFolders();
                  resolve();
                });
              },
            });
          }
        );
      }

      function getItemIcon(item) {
        // icons: repository, folder, doctype, additionalFields
        var icons = [
          'md-repository',
          'md-doc-folder',
          'md-doc-type',
          'md-add-fields',
          'md-loading',
        ];

        // icons: repositorio e pasta desabilitados
        var disabledIcons = [
          'md-repository-disabled',
          'md-folder-disabled',
          'md-doc-type',
          'md-add-fields',
          'md-loading',
        ];

        // icons: quickaccess, shared docs, none, checkuot, none, favoritos
        var quickAcess = [
          'md-alarm',
          'md-share',
          '',
          'md-file-download',
          '',
          'md-grade',
          'md md-local-print-shop',
        ];

        if (item.TreeItemType > 4) {
          //Os icons são de 5 a 10, então remove cinco pra ficar certo o indice do array
          return quickAcess[item.TreeItemType - 5];
        }

        if (item.HasPermission) {
          //Retorna os icones habilitados
          return icons[item.TreeItemType];
        } else {
          return disabledIcons[item.TreeItemType];
        }
      }

      function expandFolder(folder, e) {
        // Evita que o envento click se propague para os filhos. Ex( a.li.ul.span.a =  a -> li -> ul -> span)
        if (e !== null) {
          e.stopPropagation();
        }

        if (folder.isOpen === null) {
          folder.isOpen = true;
        } else {
          folder.isOpen = !folder.isOpen;
        }

        var isAllFolders = function (c) {
          return c.TreeItemType !== ETreeItemTypes.LOADING;
        };

        var notEmpty =
          folder.children !== undefined && folder.children !== null;

        if (
          folder.HasChildren === false ||
          (notEmpty && folder.children.every(isAllFolders))
        ) {
          return;
        }

        if (folder.children === undefined || folder.children === null) {
          folder.children = [];
        }

        var anyFolder = folder.children.some(function (c) {
          return c.TreeItemType === ETreeItemTypes.LOADING;
        });

        if (!anyFolder) {
          folder.children.push(treeService.loadingItem);
        }

        treeService.getChildren(folder).then(
          function (data) {
            data = data.filter(function (f) {
              return f.Id !== $scope.idFolderNotShow;
            });

            folder.children.forEach(function (c) {
              if (!c) {
                folder.children.splice(folder.children.indexOf(c), 1);
              } else {
                var f = folder.children.filter(function (e) {
                  return e.Id === c.Id;
                });
                if (f && f.length > 1) {
                  f.forEach(function (remove) {
                    folder.children.splice(folder.children.indexOf(remove), 1);
                  });
                }
              }
            });
            folder.children.splice(
              folder.children.indexOf(treeService.loadingItem),
              1
            );

            data.forEach(function (d) {
              //remover o item undefined
              if (
                !folder.children.some(function (c) {
                  //se não for campo adicional ou tipo de documento vai remover os itens que tem id duplicado
                  return (
                    c &&
                    c.TreeItemType !== ETreeItemTypes.DOCUMENT_TYPE &&
                    c.TreeItemType !== ETreeItemTypes.ADDITIONAL_FIELD &&
                    c.Id === d.Id
                  );
                })
              ) {
                folder.children.push(d);
              }
            });

            folder.children = $filter('orderBy')(folder.children, [
              '+TreeItemType',
              '+Name',
            ]);
          },
          function () {
            swal.fire({
              title: $filter('translate')('CHILDREN LOAD ERROR'),
              text: $filter('translate')('CHILDREN LOAD ERROR MSG'),
              icon: 'error',
              showCancelButton: true,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: $filter('translate')('RETRY'),
              showLoaderOnConfirm: true,
              preConfirm: function () {
                return new Promise(function (resolve) {
                  $scope.expandFolder(folder, e);
                  resolve();
                });
              },
            });
          }
        );
      }

      function canSelectFolder(item) {
        $scope.selectedFolder = item;
        $scope.AllFolderIsSelected = false;
        return false;
      }

      function generateMedia(value) {
        switch (value) {
          case '1':
            $scope.generateSimpleMedia(value);
            break;
          case '2':
            $scope.generateSearchableMedia(value);
            break;
        }
      }

      function generateSimpleMedia(mediaType) {
        if (
          $scope.AllFolderIsSelected === true ||
          $scope.selectedFolder === null
        ) {
          $scope.selectedFolder = {};
          $scope.selectedFolder.Id = 0;
        }

        swal.fire({
          title: $filter('translate')('WAIT SAVING'),
          text: $filter('translate')('WAIT SAVING MSG'),
          showConfirmButton: false,
          icon: 'info',
        });

        var media = new ExportedMedia();
        media.idFolder = $scope.selectedFolder.Id;
        media.mediaType = parseInt(mediaType);

        service.save(media).then(
          function () {
            swal.close();
            $uibModalInstance.close();
            $scope.$parent.alertUpdateList();
          },
          function (error) {
            swal.fire({
              title: error.title,
              text: error.text,
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          }
        );
      }

      function generateSearchableMedia(mediaType) {
        if (
          $scope.AllFolderIsSelected === true ||
          angular.equals($scope.selectedFolder, {})
        ) {
          $scope.selectedFolder = {};
          $scope.selectedFolder.Id = 0;
        }

        swal.fire({
          title: $filter('translate')('WAIT SAVING'),
          text: $filter('translate')('WAIT SAVING MSG'),
          showConfirmButton: false,
          icon: 'info',
        });

        var media = new ExportedMedia();
        media.idFolder = $scope.selectedFolder.Id;
        media.mediaType = parseInt(mediaType);

        service.save(media).then(
          function () {
            swal.close();
            $uibModalInstance.close();
            $scope.$parent.alertUpdateList();
          },
          function (error) {
            swal.fire({
              title: error.title,
              text: error.text,
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          }
        );
      }

      function selectedAllFolders() {
        $scope.AllFolderIsSelected = !$scope.AllFolderIsSelected;
        $scope.selectedFolder = null;
        return null;
      }

      function run() {
        try {
          $scope.folders = null;
          $scope.selectedFolder = null;
          $scope.AllFolderIsSelected = false;
          $scope.mediaType = '1';

          $scope.loadFolders = logWrapper(
            loadFolders,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getItemIcon = logWrapper(
            getItemIcon,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.expandFolder = logWrapper(
            expandFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSelectFolder = logWrapper(
            canSelectFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.generateMedia = logWrapper(
            generateMedia,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.generateSimpleMedia = logWrapper(
            generateSimpleMedia,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.generateSearchableMedia = logWrapper(
            generateSearchableMedia,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectedAllFolders = logWrapper(
            selectedAllFolders,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
